import { Icon } from "@cadmakers-ui/icons";
import { CalendarPickerInput } from "@cadmakers-ui/core";
import queryString from "query-string";
import React, { Dispatch } from "react";
import { connect } from "react-redux";
import { showSnack } from "react-redux-snackbar";
import { RouteComponentProps, withRouter } from "react-router";
import {
  Button,
  Col,
  Container,
  Form,
  FormGroup,
  FormText,
  Input,
  InputGroup,
  InputGroupAddon,
  Label,
  Row
} from "reactstrap";
import { UserState } from "redux-oidc";
import { Application } from "../../../App/Models/Application";
import { ResponseResult } from "../../../Common/Models/ResponseResult";
import ResponseHandler from "../../../App/ResponseHandler";
import { ApiRequest, appPaths, IAppState } from "../../../Common";
import { endpoints, SubmitResourceRequest } from "../..";
import { updateResourceRequest } from "../../Actions/FeedbackFormActions";
import { FeedbackCategory, FeedbackParent } from "../../Constants/feedbackEnums";
import ImageDropzone from "../Common/ImageDropzone/ImageDropzone";
import FileUploadButton from "../../../Common/Components/FileUploadButton/FileUploadButton";
import {
  fileService,
  imageUploadService,
  feedbackService,
  fileUploadService
} from "../../Services";
import ElementSpacer from "../../../Layout/Components/ElementSpacer";
import { Topic } from "../../../Topic/Models/Topic";
import { updateTopics } from "../../../Startup/Actions/StartupActions";
import { FeedbackFormInput } from "../Common/FeedbackFormInput";
import { Image } from "../../Models/Image";
import { DeleteImage } from "../../Models/DeleteImage";
import { feedbackFormConstants } from "../../Constants/feedbackFormConstants";
import SimilarFeedbackSuggestionsContainer from "../Common/SimilarFeedbackSuggestions/SimilarFeedbackSuggestionsContainer";
import { FeedbackFile } from "../../Models/FeedbackFile";
import { DeleteFile } from "../../Models/DeleteFile";
import FeedbackFileManager from "../Common/FeedbackFileManager/FeedbackFileManager";
import FeedbackFormTagsInput from "../Common/FeedbackFormTagsInput";
import FeedbackFormIsPrivateInput from "../Common/FeedbackFormIsPrivateInput";
import FeedbackFormResourceRequestCategoryInput from "../Common/FeedbackFormResourceRequestCategoryInput";
import iconStyles from "../../../Common/Styles/Icons.module.scss";
import { userService } from "../../../User";

type Props = {
  selectedApp?: Application;
  selectedTopic?: Topic;
  selectedParent: FeedbackParent;
  code: string;
};

type StateProps = {
  resourceRequest: SubmitResourceRequest;
  topics: Topic[];
  user: UserState;
};

type DispatchProps = {
  updateResourceRequest: (resourceRequest: SubmitResourceRequest) => void;
  showSnack: (uniqueId: any, args: any) => void;
  updateTopics: (topics: Topic[]) => void;
};

type State = {
  resourceRequest: SubmitResourceRequest;
  canSubmit: boolean;
  images: Image[];
  files: FeedbackFile[];
};

const mapStateToProps = (state: IAppState) => ({
  resourceRequest: state.feedbackForm.resourceRequest,
  topics: state.app.topics,
  user: state.oidc
});

const mapDispatchToProps = (dispatch: Dispatch<any>) => ({
  updateResourceRequest: (resourceRequest: SubmitResourceRequest) =>
    dispatch(updateResourceRequest(resourceRequest)),
  showSnack: (uniqueId: any, args: any) => dispatch(showSnack(uniqueId, args)),
  updateTopics: (topics: Topic[]) => dispatch(updateTopics(topics))
});

class ResourceRequestForm extends React.Component<
  Props & StateProps & DispatchProps & RouteComponentProps,
  State
> {
  private imageUploadPendingCount: number;

  private fileUploadPendingCount: number;

  constructor(props: Props & StateProps & DispatchProps & RouteComponentProps) {
    super(props);

    this.state = {
      resourceRequest: this.props.resourceRequest,
      canSubmit: true,
      images: [],
      files: []
      // dueDateDatePickerActual: new Date()
    };

    this.imageUploadPendingCount = 0;
    this.fileUploadPendingCount = 0;
  }

  componentWillUnmount = () => {
    this.props.updateResourceRequest(this.state.resourceRequest);
  };

  getResourceRequestBody = () => {
    return {
      title: this.state.resourceRequest.title,
      appRolePrefix: this.props.selectedApp ? this.props.selectedApp.rolePrefix : null,
      topicCode: this.props.selectedTopic ? this.props.selectedTopic.code : null,
      feedbackCategory: FeedbackCategory[FeedbackCategory.ResourceRequest],
      feedbackParent: this.props.selectedParent,
      description: this.state.resourceRequest.description,
      categoryName: this.state.resourceRequest.categoryName,
      specSheetLink: this.state.resourceRequest.specSheetLink,
      imageRefs: this.state.images,
      files: this.state.files,
      tagIds: this.state.resourceRequest.tagIds,
      isPrivate: this.state.resourceRequest.isPrivate,
      dueDate: this.state.resourceRequest.dueDate
    };
  };

  clearForm = () => {
    this.setState({
      resourceRequest: {
        title: "",
        description: "",
        categoryName: "",
        specSheetLink: "",
        tagIds: [],
        isPrivate: true
      }
    });
  };

  onChangeTags = (tagIds: number[]) => {
    this.setState(prevState => ({
      resourceRequest: { ...prevState.resourceRequest, tagIds }
    }));
  };

  onChangeIsPrivate = (isPrivate: boolean) => {
    this.setState(prevState => ({
      resourceRequest: { ...prevState.resourceRequest, isPrivate }
    }));
  };

  onChangeDate = (dueDate: Date) => {
    this.setState(prevState => ({
      resourceRequest: { ...prevState.resourceRequest, dueDate }
    }));
  };

  /* onChangeDatepickerActual = (actual: Date) => {
    this.setState(prevState => ({
      dueDateDatePickerActual: actual
    }));
  }; */

  onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    if (this.imageUploadPendingCount > 0) {
      this.showErrorSnackbar(
        "Failed to submit resource request",
        "Please wait until all images are finished uploading"
      );
      return;
    }

    this.setState({
      canSubmit: false
    });

    let redirect: boolean = false;

    ApiRequest.fromPath(endpoints.feedback.create(this.props.code))
      .withAuthHeader()
      .withJson(this.getResourceRequestBody())
      .post()
      .then(async (response: Response) => {
        await ResponseHandler.handle(
          response,
          () => {
            if (this.props.selectedParent === FeedbackParent.Topic) {
              const topicsCopy = [...this.props.topics];
              const topicIndex = topicsCopy.findIndex(
                topic => (this.props.selectedTopic as Topic).code === topic.code
              );

              if (topicIndex !== -1) {
                topicsCopy[topicIndex].resourceRequestCount++;
              }

              this.props.updateTopics(topicsCopy);
            }

            this.clearForm();
            redirect = true;
          },
          (result: ResponseResult) => {
            this.showErrorSnackbar(
              "Failed to create resource request",
              result.error.message,
              response.status
            );
          },
          () => {
            this.showErrorSnackbar(
              "Failed to create resource request",
              "An unknown error has occured",
              response.status
            );
          }
        );
      })
      .finally(() => {
        this.setState({
          canSubmit: true
        });

        if (redirect && this.props.code) {
          switch (this.props.selectedParent) {
            case FeedbackParent.Application:
              this.props.history.push(
                feedbackService.getViewUrlForCodeAndAppRolePrefix(
                  this.props.code,
                  (this.props.selectedApp as Application).rolePrefix,
                  FeedbackCategory.ResourceRequest
                )
              );
              break;
            case FeedbackParent.Topic:
              this.props.history.push(
                feedbackService.getViewUrlForCodeAndTopicCode(
                  this.props.code,
                  (this.props.selectedTopic as Topic).code,
                  FeedbackCategory.ResourceRequest
                )
              );
              break;
            default:
              break;
          }
        }
      });
  };

  onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    const { name } = event.target;

    this.setState(prevState => ({
      resourceRequest: { ...prevState.resourceRequest, [name as any]: value }
    }));
  };

  onChangeCategory = (newCategory: string) => {
    this.setState(prevState => ({
      resourceRequest: { ...prevState.resourceRequest, categoryName: newCategory }
    }));
  };

  onImagesAdded = (images: Image[]) => {
    if (this.props.code) {
      this.imageUploadPendingCount += images.length;

      images.forEach(async image => {
        await imageUploadService.uploadImage(
          endpoints.feedback.images.uploadTemp(this.props.code),
          image,
          newImage => {
            this.setState(prevState => ({
              images: prevState.images.concat(newImage)
            }));
          },
          hash => {
            return this.state.images.find(x => x.fullSizeHash === hash);
          },
          () => {
            this.showErrorSnackbar(
              "Failed to upload image",
              "This image has already been uploaded"
            );
          },
          (response, result) => {
            this.showErrorSnackbar("Failed to upload image", result.error.message, response.status);
          },
          response => {
            this.showErrorSnackbar(
              "Failed to upload image",
              "An unknown error has occured",
              response.status
            );
          }
        );
        this.imageUploadPendingCount--;
      });
    } else {
      this.showErrorSnackbar("Failed to upload image", "Feedback code was not generated");
    }
  };

  onImageDelete = (image: Image) => {
    const deleteModel: DeleteImage = {
      fullSizeObjectPath: image.fullSizeObjectPath,
      thumbnailObjectPath: image.thumbnailObjectPath
    };

    imageUploadService.deleteImage(
      endpoints.feedback.images.deleteTemp(),
      deleteModel,
      () => {
        this.setState(prevState => ({
          images: prevState.images.filter(i => i !== image)
        }));
      },
      (response, result) => {
        this.showErrorSnackbar("Failed to remove image", result.error.message, response.status);
      },
      response => {
        this.showErrorSnackbar(
          "Failed to remove image",
          "An unknown error has occured",
          response.status
        );
      }
    );
  };

  onFilesAdded = (files: FeedbackFile[], isCadmakersOnly: boolean) => {
    if (this.props.code) {
      this.fileUploadPendingCount += files.length;

      files.forEach(async file => {
        await fileUploadService.uploadFile(
          endpoints.feedback.files.uploadTemp(this.props.code, isCadmakersOnly),
          file,
          newFile => {
            this.setState(prevState => ({
              files: prevState.files.concat(newFile)
            }));
          },
          hash => {
            return this.state.files.find(x => x.hash === hash);
          },
          () => {
            this.showErrorSnackbar("Failed to upload file", "This file has already been uploaded");
          },
          (response, result) => {
            this.showErrorSnackbar(
              "Failed to upload file",
              result?.error?.message ?? "",
              response.status
            );
          },
          response => {
            this.showErrorSnackbar(
              "Failed to upload file",
              "An unknown error has occured",
              response.status
            );
          }
        );

        this.fileUploadPendingCount--;
      });
    } else {
      this.showErrorSnackbar("Failed to upload file", "Feedback code was not generated");
    }
  };

  onFileDelete = (file: FeedbackFile) => {
    const deleteModel: DeleteFile = {
      path: file.path
    };

    fileUploadService.deleteFile(
      endpoints.feedback.files.deleteTemp(),
      deleteModel,
      () => {
        this.setState(prevState => ({
          files: prevState.files.filter(f => f !== file)
        }));
      },
      (response, result) => {
        this.showErrorSnackbar("Failed to remove file", result.error.message, response.status);
      },
      response => {
        this.showErrorSnackbar(
          "Failed to remove file",
          "An unknown error has occured",
          response.status
        );
      }
    );
  };

  onImageUploadClick = (files: File[]) => {
    this.onImagesAdded(fileService.filestoImages(files));
  };

  onFileUploadClick = (files: File[]) => {
    this.onFilesAdded(fileService.filestoFeedbackFiles(files, false), false);
  };

  onCadmakersFileUploadClick = (files: File[]) => {
    this.onFilesAdded(fileService.filestoFeedbackFiles(files, true), true);
  };

  showErrorSnackbar = (reason: string, errorDescription: string, errorCode?: number) => {
    let label = `${reason}: ${errorDescription}`;

    if (errorCode) {
      label += `(Error Code ${errorCode})`;
    }

    this.props.showSnack("COMMENT_BOX", {
      label,
      timeout: 5000
    });
  };

  render() {
    const isCadmakers = userService.isUserCadmakers(this.props.user);

    return (
      <Form onSubmit={e => this.onSubmit(e)}>
        <Row>
          <Col lg={6}>
            <FeedbackFormInput
              label=" Title (Brief Description)"
              type="text"
              name="title"
              autoComplete="off"
              required
              value={this.state.resourceRequest.title}
              onChange={e => this.onChange(e)}
              description="This is the displayed title for the resource request. Please make it concise."
            />
          </Col>
          {this.state.resourceRequest.title.length >=
            feedbackFormConstants.minLengthForSimilarNames && (
            <Col lg={6}>
              <SimilarFeedbackSuggestionsContainer
                query={this.state.resourceRequest.title}
                selectedParent={this.props.selectedParent}
                selectedApp={this.props.selectedApp}
                selectedTopic={this.props.selectedTopic}
              />
            </Col>
          )}
        </Row>
        <Row>
          <Col lg={6}>
            <FeedbackFormTagsInput
              selectedTagIds={this.state.resourceRequest.tagIds}
              onChangeTags={this.onChangeTags}
            />
          </Col>
          <Col lg={6}>
            <FeedbackFormIsPrivateInput
              isChecked={this.state.resourceRequest.isPrivate}
              onChange={this.onChangeIsPrivate}
            />
          </Col>
        </Row>
        <FeedbackFormInput
          label="Description"
          rows={3}
          type="textarea"
          name="description"
          value={this.state.resourceRequest.description}
          onChange={e => this.onChange(e)}
          description="Description of the resource. Any important considerations. Links to images, supplier catalog"
        />
        <Row>
          <Col lg={6}>
            <FeedbackFormResourceRequestCategoryInput
              selectedCategory={this.state.resourceRequest.categoryName}
              onChangeCategory={this.onChangeCategory}
            />
          </Col>
        </Row>
        <FormGroup>
          <Label for="link">Spec sheet link</Label>
          <InputGroup>
            <InputGroupAddon addonType="prepend">
              <span className="input-group-text">
                <Icon
                  appName="GeneralLayout"
                  assetName="GENERAL_L_ChainLink"
                  className={iconStyles.smallIcon}
                />
              </span>
            </InputGroupAddon>
            <Input
              type="text"
              name="specSheetLink"
              autoComplete="off"
              value={this.state.resourceRequest.specSheetLink}
              onChange={e => this.onChange(e)}
            />
          </InputGroup>
          <FormText>If available, a link to a sample spec sheet</FormText>
        </FormGroup>

        {/* <FormGroup>
          <Label for="dueDate">
            <ElementSpacer spacing=".25rem">Due Date</ElementSpacer>
          </Label>
          <div style={{ width: 135 }}>
            <CalendarPickerInput
              value={
                {
                  selectedDate: this.state.resourceRequest.dueDate,
                  actual: this.state.dueDateDatePickerActual
                } as any
              }
              onChange={this.onChangeDate}
              onChangeMonth={this.onChangeDatepickerActual}
              disabledDays={[
                {
                  before: new Date()
                }
              ]}
            />
          </div>
          <FormText>
            Due date for this feedback to be progressed to the next workflow status
          </FormText>
        </FormGroup> */}

        <Row>
          <Col>
            <ImageDropzone
              images={this.state.images}
              onImagesAdded={this.onImagesAdded}
              onImageDelete={this.onImageDelete}
            />
          </Col>
        </Row>
        <hr />
        <Row>
          <Col>
            <FeedbackFileManager
              files={this.state.files.filter(f => !f.isCadmakersOnly)}
              onFilesAdded={this.onFilesAdded}
              onFileDelete={this.onFileDelete}
              isCadmakersOnly={false}
            />
          </Col>
        </Row>
        {isCadmakers && (
          <Row>
            <Col>
              <br />
              <FeedbackFileManager
                files={this.state.files.filter(f => f.isCadmakersOnly)}
                onFilesAdded={this.onFilesAdded}
                onFileDelete={this.onFileDelete}
                isCadmakersOnly
              />
            </Col>
          </Row>
        )}
        <hr />
        <Row>
          <Col xs="auto">
            <ElementSpacer>
              <Button disabled={!this.state.canSubmit}>Submit</Button>
              <Button onClick={this.clearForm}>Clear</Button>
              <FileUploadButton onClick={this.onImageUploadClick}>Upload Images</FileUploadButton>
              <FileUploadButton onClick={this.onFileUploadClick}>Upload Files</FileUploadButton>
              {isCadmakers && (
                <FileUploadButton onClick={this.onCadmakersFileUploadClick}>
                  Upload Cadmakers Internal Files
                </FileUploadButton>
              )}
            </ElementSpacer>
          </Col>
        </Row>
      </Form>
    );
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ResourceRequestForm));
